import Typed from "typed.js";

var options = {
    strings: [
        "Cerca per marca",
        "Cerca per modello ",
        "Cerca per allestimento "
    ],
    typeSpeed: 60,
    backSpeed: 50,
    attr: "placeholder",
    smartBackspace: true,
    bindInputFocusEvents: true,
    loop: true,
};

var typedDesktop = document.getElementById("searchtextdesktop");
var typedMobile = document.getElementById("searchtextmobile");

if (typedDesktop) {
    var typed = new Typed(typedDesktop, options);
}
if (typedMobile) {
    var typed_mobile = new Typed(typedMobile, options);
}
